import React from 'react';
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import _ from 'lodash';
import Tooltip from '@/components/common/Elements/Tooltip/Tooltip';

// import Link from "./Triggers/Link/Link";
import Input from './Triggers/Input/Input';
import Option from './Option/Option';

class SelectOptions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      options: [],
      selected: {},
      anchorEl: null,
      showSelected: true,
      inputValue: '',
      index: 0,
    };

    _.map(['scrollTop', 'scrollDown'], (fn) => {
      this[fn] = this[fn].bind(this);
    });
  }

  componentDidMount() {
    const updatedOptions = [
      ...(this.props.firstIsNull
        ? [{ value: null, label: this.props.placeholder }]
        : []),
      ...this.props.options,
    ];
    this.setState({
      ...this.state,
      selected: (this.props.selected || {}).value
        ? this.props.selected
        : this.props.options.length > 0 && this.props.isFirstItemSelected
          ? updatedOptions[0]
          : {},
      options: updatedOptions,
    });
  }

  shouldComponentUpdate(nextProps) {
    const updatedOptions = [
      ...(nextProps.firstIsNull
        ? [{ value: null, label: nextProps.placeholder }]
        : []),
      ...nextProps.options,
    ];
    if (
      !_.isEqual(nextProps.options, this.props.options) ||
      !_.isEqual(nextProps.selected, this.props.selected)
    ) {
      this.setState({
        ...this.state,
        ...{
          options: updatedOptions,
          ...((nextProps.selected || {}).value
            ? { selected: nextProps.selected }
            : { selected: {} }),
        },
      });
    }
    if (
      !_.isEqual(nextProps.isClose, this.props.isClose) &&
      nextProps.isClose === true
    ) {
      this.setState({
        ...this.state,
        selected: nextProps.retainSelected ? nextProps.selected : {},
        anchorEl: null,
      });
    }

    return true;
  }

  scrollTop() {
    const { index } = this.state;
    const idx = index - 3;

    if (this.refs[`select_option_${idx}`]) {
      this.refs[`select_option_${idx}`].scrollIntoView();

      this.setState({ index: idx }, () => {
        if (Object.keys(this.refs).length - idx > 5) {
          $('#scrollDown').show();
        }
        if (idx < 1) {
          $('#scrollTop').hide();
        }
      });
    }
  }

  scrollDown() {
    const { index } = this.state;
    const idx = index + 3;

    if (this.refs[`select_option_${idx}`]) {
      this.refs[`select_option_${idx}`].scrollIntoView();

      this.setState({ index: idx }, () => {
        if (Object.keys(this.refs).length - idx <= 5) {
          $('#scrollDown').hide();
        }
        if (idx > 0) {
          $('#scrollTop').show();
        }
      });
    }
  }

  render() {
    const { props, state } = this;
    const open = Boolean(state.anchorEl);

    const handleClick = (event) => {
      this.setState({ ...this.state, anchorEl: event.currentTarget });
    };

    const handleClose = () => {
      this.setState({ ...this.state, anchorEl: null });
    };

    const handleStateUpdate = (update, cb) => {
      this.setState({ ...this.state, ...update }, cb);
    };
    let activeOptions = state.options.filter((a) => a.section === 'active');
    let completedOptions = state.options.filter(
      (a) => a.section === 'completed'
    );
    const otherProps = this.props.otherProps;
    const hasRetriction = otherProps.hasRetriction
      ? otherProps.hasRetriction
      : false;
    const message =
      hasRetriction && otherProps.message ? otherProps.message : '';
    const isSelectedVisible = hasRetriction.isSelectedVisible
      ? hasRetriction.isSelectedVisible
      : true;

    if (!isSelectedVisible) {
      activeOptions = activeOptions.filter(
        (option) => option.value !== state.selected.value
      );
      completedOptions = completedOptions.filter(
        (option) => option.value !== state.selected.value
      );
    }

    return (
      <div
        class={`selectMultipleContainer ${props.classes.main} ${props.isSearchable ? 'searchable' : ''}`}
      >
        <div class="selectedValue">
          {/* {!props.isSearchable && !isNav && (
                        <Link 
                            type={props.type}
                            open={open}
                            selected={state.selected}
                            onTrigger={handleClick}
                            placeholder={this.props.placeholder}
                            useValue={props.useValue}
                            renderSelected={props.renderSelected}
                        />
                    )} */}
          {props.isSearchable && (
            <Input
              state={state}
              open={open}
              onInputChange={props.handleSearch}
              options={props.options}
              placeholder={props.placeholder}
              showSelectedInInput={props.showSelectedInInput}
              renderSelected={props.renderSelected}
              onTrigger={handleClick}
              onUpdateState={handleStateUpdate}
              onOpen={props.onOpen}
              onSearch={props.onSearch}
              onClearSelected={props.onClearSelected}
              value={this.state.inputValue}
              searchIcon={props.searchIcon}
              clearIcon={props.clearIcon}
              disabled={props.disabled}
            />
          )}
        </div>
        <Popper
          open={open}
          anchorEl={state.anchorEl}
          placement="bottom-start"
          style={{ zIndex: 9999 }}
        >
          <ClickAwayListener onClickAway={handleClose}>
            <div class={`selectMultipleOptions ${props.classes.options}`}>
              <div
                class={` scrollContainer ${props.hasScroll ? ' active' : ''}`}
              >
                <div class="selectOptionHeader">
                  <p>Active/ Delayed Tasks </p>
                  <p>Adjusted Date</p>
                </div>
                {activeOptions.length > 0 &&
                  activeOptions.map((option, i) => {
                    return (
                      <div class="optionContainer" ref={`select_option_${i}`}>
                        <Option
                          key={`selectOptionKey_${option.value}`}
                          option={option}
                          selected={state.selected}
                          closeOnChange={props.closeOnChange}
                          renderOption={props.renderOption}
                          onUpdateState={handleStateUpdate}
                          onChange={props.onChange}
                          onClose={handleClose}
                          link={props.link}
                        />
                      </div>
                    );
                  })}
                {activeOptions.length === 0 &&
                  !(props.loadingObj && props.loadingObj.isLoadingActive) && (
                    <div class="selectOption">
                      <div class="optionTrigger">
                        <span>No Results Found</span>
                      </div>
                    </div>
                  )}
                {props.loadingObj && props.loadingObj.isLoadingActive && (
                  <div class="selectOption">
                    <div class="optionTrigger">
                      <span>Loading...</span>
                    </div>
                  </div>
                )}
                {props.bottomContent &&
                  activeOptions.length >= 10 &&
                  activeOptions[0].total > 10 &&
                  activeOptions.length !== activeOptions[0].total && (
                    <div class="selectBottomContent">
                      {props.bottomContent(activeOptions[0].section)}
                    </div>
                  )}
              </div>
              <div
                class={` scrollContainer ${props.hasScroll ? ' active' : ''}`}
              >
                <div class="selectOptionHeader">
                  <p
                    class={`${hasRetriction ? 'hasRetriction' : ''}`}
                    data-tooltip-id={`restriction-info`}
                  >
                    <span>Completed Tasks</span>
                    {hasRetriction && (
                      <React.Fragment>
                        <i class="material-icons">info</i>
                        <Tooltip
                          id={`restriction-info`}
                          place="bottom"
                          effect="solid"
                          clickable={true}
                        >
                          {message}
                        </Tooltip>
                      </React.Fragment>
                    )}
                  </p>
                  <p>Completed Date</p>
                </div>
                {completedOptions.length > 0 &&
                  completedOptions.map((option, i) => {
                    return (
                      <div class="optionContainer" ref={`select_option_${i}`}>
                        <Option
                          key={`selectOptionKey_${option.value}`}
                          option={option}
                          selected={state.selected}
                          closeOnChange={props.closeOnChange}
                          renderOption={props.renderOption}
                          onUpdateState={handleStateUpdate}
                          onChange={props.onChange}
                          onClose={handleClose}
                          link={props.link}
                        />
                      </div>
                    );
                  })}
                {completedOptions.length === 0 &&
                  !(
                    props.loadingObj && props.loadingObj.isLoadingCompleted
                  ) && (
                    <div class="selectOption">
                      <div class="optionTrigger">
                        <span>No Results Found</span>
                      </div>
                    </div>
                  )}
                {props.loadingObj && props.loadingObj.isLoadingCompleted && (
                  <div class="selectOption">
                    <div class="optionTrigger">
                      <span>Loading...</span>
                    </div>
                  </div>
                )}
                {props.bottomContent &&
                  completedOptions.length >= 10 &&
                  completedOptions[0].total > 10 &&
                  completedOptions.length !== completedOptions[0].total && (
                    <div class="selectBottomContent">
                      {props.bottomContent(completedOptions[0].section)}
                    </div>
                  )}
              </div>
            </div>
          </ClickAwayListener>
        </Popper>
      </div>
    );
  }
}

SelectOptions.defaultProps = {
  options: [{ value: '', label: 'No options' }],
  closeOnChange: true,
  classes: {
    main: '',
    options: '',
  },
  selected: {},
  showSelectedInInput: true,
  showSelectedInOptions: true,
  exclude: [],
  placeholder: 'Select',
  isFirstItemSelected: true,
};

export default SelectOptions;
